import styled from 'styled-components';

import { Color } from '../../enums';
import { StyledComponent } from '../../interfaces';

export const Container: StyledComponent<'div'> = styled.div`
  border-radius: 4px;
  background: rgba(0, 0, 0, 0.25);
  padding: 16px;
  display: flex;
  align-items: center;
  width: fit-content;
`;

export const LikeIconContainer: StyledComponent<'button'> = styled.button.attrs({ type: 'button' })`
  width: 32px;
  height: 32px;
  background-color: ${Color.Black};
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-shrink: 0;
  margin-right: 12px;
`;

export const DescriptionContainer: StyledComponent<'div'> = styled.div`
  font-size: 14px;
  line-height: 18px;
  color: ${Color.White};
`;

export const Author: StyledComponent<'div'> = styled.div``;

export const Description: StyledComponent<'div'> = styled.div``;
